import React, { type ButtonHTMLAttributes, type PropsWithChildren } from 'react';
import styled from 'styled-components';
import { FontSize16, Spacing16 } from 'autogen/design-tokens/tokens';

const Item = styled.div`
    margin: 0;
    border: 0;
    width: 100%;
    text-align: left;
    background: transparent;
    padding: ${Spacing16} 0;
    font-weight: bold;
    font-size: ${FontSize16};
`;

type SimpleItemProps = PropsWithChildren;

export default function SimpleItem(props: SimpleItemProps) {
    const { children, ...restProps } = props;

    return <Item {...restProps}>{children}</Item>;
}
